export const GOOGLE_PAY_LEGAL_LINKS = {
    terms: {
        us: 'https://support.google.com/googlepay/answer/9039712?hl=en',
        caEn: 'https://support.google.com/googlepay/answer/9039712?hl=en',
        caFr: 'https://support.google.com/googlepay/answer/9039712?hl=fr'
    },
    privacy: {
        us: 'https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice',
        caEn: 'https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice',
        caFr: 'https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice&ldl=fr-CA'
    }
};
